/* eslint-disable no-magic-numbers */
import { ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from '../components/storelocator.component';
import { GOOGLEMAPSERVICE } from './google.map.service';

export class GoogleMarkerService {
  /**
   * Propertys
   */
  markerLibrary: google.maps.MarkerLibrary;
  latLngBounds: google.maps.LatLngBounds;
  map: google.maps.Map;
  prefilterItems = [];
  markers = [];

  getMarkers() {
    return this.markers;
  }

  // Sets the map on all markers in the array.
  setMapOnAll(map) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
  }

  // Removes the markers from the map, but keeps them in the array.
  hideMarkers() {
    this.setMapOnAll(null);
  }

  // Shows any markers currently in the array.
  showMarkers() {
    this.setMapOnAll(this.map);
  }

  showAllMarkers(markerBounds) {
    this.map.fitBounds(markerBounds);
  }

  // Deletes all markers in the array by removing references to them.
  deleteMarkers() {
    this.hideMarkers();
    this.markers = [];
  }

  showLocationMarker(id: string) {
    for (let i = 0; i < this.markers.length; i++) {
      const currentMarker = this.markers[i];
      if (currentMarker.id === id) {
        this.map.panTo(currentMarker.position);
        this.map.setZoom(17);
      }
    }
  }

  createMyLocationMarker(geoCoords: object) {
    for (let i = 0; i < this.markers.length; i++) {
      if (this.markers[i].id === 'myLocation') {
        return;
      }
    }
    this.addMyLocationMarker(geoCoords);
  }

  addMyLocationMarker(geoCoords: object) {
    const parser = new DOMParser();
    const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
    <path d="m280-40 112-564-72 28v136h-80v-188l202-86q14-6 29.5-7t29.5 4q14 5 26.5 14t20.5 23l40 64q26 42 70.5 69T760-520v80q-70 0-125-29t-94-74l-25 123 84 80v300h-80v-260l-84-64-72 324h-84Zm260-700q-33 0-56.5-23.5T460-820q0-33 23.5-56.5T540-900q33 0 56.5 23.5T620-820q0 33-23.5 56.5T540-740Z" fill="#4286f6" stroke="white" stroke-width="4"/>
    </svg>
    `;
    const svgMarker = parser.parseFromString(svgString, 'image/svg+xml').documentElement;
    this.addMarker(geoCoords, svgMarker, '', 'myLocation');
  }

  /**
   * Handles Markers
   */
  async handleMarkers(items) {
    this.markerLibrary = (await GOOGLEMAPSERVICE.gmapService.importLibrary('marker')) as google.maps.MarkerLibrary;
    this.latLngBounds = new google.maps.LatLngBounds();

    const parser = new DOMParser();
    const svgString = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21" fill="none">
      <rect width="20" height="20" rx="10" fill="#4286f6" stroke="white" stroke-width="2"></rect>
      </svg>`;
    const svgMarker = parser.parseFromString(svgString, 'image/svg+xml').documentElement;

    this.addMarker(STORELOCATORCOMPONENT.geoCoords, svgMarker, '');

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      const image = document.createElement('img');
      image.src = item.icon_url;

      const LanLng = { lat: Number(item.latitude), lng: Number(item.longitude) };

      const title = item.name;
      const locId = item.loc_id;

      if (ConfigData.data['prefilter'] && !this.prefilterItems.includes(locId)) {
        this.addMarker(LanLng, image, title, locId, null);
      } else {
        this.addMarker(LanLng, image, title, locId);
      }

      this.latLngBounds.extend(LanLng);
    }

    if (items.length === 1) {
      this.showLocationMarker(items[0].loc_id);
    } else {
      this.map.fitBounds(this.latLngBounds);
    }
  }

  /**
   * https://developers.google.com/maps/documentation/javascript/advanced-markers/basic-customization?hl=de
   * https://developers.google.com/maps/documentation/javascript/advanced-markers/html-markers?hl=de
   * https://developers.google.com/maps/documentation/javascript/examples/advanced-markers-graphics?hl=de
   * https://developers.google.com/maps/documentation/javascript/advanced-markers/html-markers?hl=de#animated_markers
   */
  addMarker(position: object, image: HTMLElement, title: string, locId?: string, map?: google.maps.Map | null) {
    const currentMap = map === null ? null : this.map;
    const markerElement = new this.markerLibrary.AdvancedMarkerElement({
      map: currentMap,
      position: position as google.maps.LatLngLiteral,
      content: image,
      title: title,
    });
    if (locId) {
      markerElement.id = locId;
    }

    if (!ConfigData.data['singleLocations']) {
      this.setMarkerClickListener(markerElement);
    }

    this.markers.push(markerElement);
  }

  // Sets a click listener for each marker
  setMarkerClickListener(marker) {
    marker.addListener('gmp-click', () => {
      this.handleMarkerSideBarInteraction(marker);
    });
  }

  // Handles interaction with the sidebar when a marker is clicked
  handleMarkerSideBarInteraction(marker) {
    const sidebarBodyChildren = STORELOCATORCOMPONENT.sidebarHtmlElement.querySelector('cwc-sidebar-body').childNodes;

    sidebarBodyChildren.forEach(function (e: HTMLElement) {
      const detailsInfo = e.querySelector('cwc-location-info > div.info-content') as HTMLElement;
      if (e.getAttribute('id') == marker.id) {
        const hasBackButton =
          STORELOCATORCOMPONENT.sidebarHtmlElement.querySelector<HTMLElement>('button.location-back');
        if (hasBackButton) hasBackButton.click();
        detailsInfo.click();
      }
    });
  }

  handleMarker(action, storeId) {
    switch (action) {
      case 'show':
        for (let i = 0; i < this.markers.length; i++) {
          if (this.markers[i].id === storeId) {
            this.markers[i].setMap(this.map);
          }
        }
        break;
      case 'hide':
        for (let i = 0; i < this.markers.length; i++) {
          if (this.markers[i].id === storeId) {
            this.markers[i].setMap(null);
          }
        }
        break;
      case 'showAll':
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(this.map);
        }
        break;
    }
  }
}

export const MARKER = new GoogleMarkerService();
